import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";

import { cn } from "../lib/utils";
import { CommandFooter } from "./ui/command";
import { Kbd, KbdGroup } from "./ui/kbd";

interface CommandPaletteFooterHintsProps {
  /** Adds the "Backspace / Back" hint, shown only while a submenu is open. */
  readonly isSubmenu: boolean;
}

/**
 * The static keyboard-hint strip pinned to the bottom of the palette. Pulled
 * out of `OpenCommandPaletteDialog` (apps/web/src/components/CommandPalette.tsx)
 * — it renders the same markup regardless of any other state in that
 * component, so it is a complete, prop-controlled boundary.
 */
export function CommandPaletteFooterHints({ isSubmenu }: CommandPaletteFooterHintsProps) {
  return (
    <CommandFooter className="gap-3 max-sm:flex-col max-sm:items-start">
      <div className="flex items-center gap-3">
        <KbdGroup className="items-center gap-1.5">
          <Kbd>
            <ArrowUpIcon />
          </Kbd>
          <Kbd>
            <ArrowDownIcon />
          </Kbd>
          <span className={cn("text-muted-foreground/80")}>Navigate</span>
        </KbdGroup>
        <KbdGroup className="items-center gap-1.5">
          <Kbd>Enter</Kbd>
          <span className={cn("text-muted-foreground/80")}>Select</span>
        </KbdGroup>
        {isSubmenu ? (
          <KbdGroup className="items-center gap-1.5">
            <Kbd>Backspace</Kbd>
            <span className={cn("text-muted-foreground/80")}>Back</span>
          </KbdGroup>
        ) : null}
        <KbdGroup className="items-center gap-1.5">
          <Kbd>Esc</Kbd>
          <span className={cn("text-muted-foreground/80")}>Close</span>
        </KbdGroup>
      </div>
    </CommandFooter>
  );
}
